import React from 'react';
import { Section } from './ui/Section';
import { Star, Quote } from 'lucide-react';
import { motion } from 'framer-motion';
export function Testimonials() {
  const reviews = [{
    text: 'Donavan did outstanding work selling our house and helped with our specific challenge. Very respectful young man.',
    author: 'Olayinka',
    role: 'Seller'
  }, {
    text: 'Donavan is a BEAST! He really knows the ins and outs of everything to do with real estate, cash offers, and is extremely reliable.',
    author: 'Jett',
    role: 'Investor'
  }];
  return <Section id="testimonials" background="white" data-id="element-169">
      <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-170">
        <h4 className="text-brand-gold font-bold uppercase tracking-widest text-sm mb-2" data-id="element-171">
          Client Stories
        </h4>
        <h2 className="text-3xl md:text-4xl font-bold text-brand-dark" data-id="element-172">
          Trusted by Families & Investors
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-173">
        {reviews.map((review, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: index * 0.2
      }} className="bg-brand-light p-10 relative rounded-sm" data-id="element-174">
            <Quote className="absolute top-6 left-6 w-10 h-10 text-brand-gold/20" data-id="element-175" />
            <div className="flex space-x-1 mb-6 text-brand-gold" data-id="element-176">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-177" />)}
            </div>
            <p className="text-gray-700 text-lg italic mb-6 leading-relaxed" data-id="element-178">
              "{review.text}"
            </p>
            <div data-id="element-179">
              <p className="font-bold text-brand-dark font-heading" data-id="element-180">
                {review.author}
              </p>
              <p className="text-sm text-gray-500 uppercase tracking-wide" data-id="element-181">
                {review.role}
              </p>
            </div>
          </motion.div>)}
      </div>
    </Section>;
}